export default __webpack_public_path__ + "static/media/18.fdd8baa5.jpg";